import React, { useState } from "react";
import { Carousel, Modal, Flex, Typography } from "antd";

const { Paragraph } = Typography;

const ReviewCard = ({ review }) => {
  const [open, setOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleOpen = (index = 0) => {
    setCurrentSlide(index);
    setOpen(true);
  };

  return (
    <Flex
      justify="center"
      gap={40}
      className="flex-col md:flex-row items-stretch"
    >
      {/* Review Text */}
      <Paragraph className="flex-[2] text-xs font-medium text-justify">
        {review.review_text?.[0]?.children?.[0]?.text || ""}
      </Paragraph>

      {/* Thumbnail Image */}
      <div
        className="relative flex-1 cursor-pointer transition-transform duration-300 hover:scale-105"
        onClick={() => handleOpen(0)}
      >
        {review.review_image?.[0]?.url ? (
          <img
            src={`${process.env.REACT_APP_API_URL}${review.review_image[0].url}`}
            alt={review.review_image[0].name || "review"}
            className="w-80 h-full object-cover rounded-xl shadow-md"
          />
        ) : (
          <div className="w-80 h-full flex items-center justify-center bg-gray-100 rounded-xl">
            <span className="text-gray-400 text-sm">No images available</span>
          </div>
        )}
      </div>

      {/* Fullscreen Modal with Slider */}
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
        width="90%"
        className="!p-0 !bg-transparent"
        bodyStyle={{ padding: 0, background: "transparent" }}
      >
        <Carousel
          initialSlide={currentSlide}
          arrows
          infinite= {false}
          className="w-full"
          afterChange={(index) => setCurrentSlide(index)}
        >
          {review.review_image?.map((img) => (
            <div
              key={img.id}
              className="flex justify-center items-center bg-black"
            >
              
              <img
                src={`${process.env.REACT_APP_API_URL}${img.url}`}
                alt={img.name || "review"}
                className="w-full h-full object-contain"
              />
            </div>
          ))}
        </Carousel>
      </Modal>
    </Flex>
  );
};

export default ReviewCard;
